/* Captación de correo: lo que el flyout nativo del tema no sabe hacer solo.
   Ver assets/hai-captura.css y la sección `hai_captura` de footer-group.json.

   El tema (PromoPopup en global.js) abre el flyout al 50 % del scroll y, al
   cerrarlo, deja una cookie con el nombre de la sección por `frequency`
   horas. Lo que le falta:

   1. Shopify procesa el formulario recargando la página. En esa recarga el
      éxito se imprime dentro del flyout, que está cerrado, y como no hubo
      "cerrar" no hay cookie: volvería a pedir el correo en la próxima visita.
      Aquí, si la página trae el "Listo…" de CUALQUIER formulario de
      newsletter (flyout, footer o sección de la página), se fija la cookie
      del flyout por un año y se vuelve a fijar cuando el tema la acorte al
      cerrar (el tema escribe la suya en el mismo clic; esta corre después).
   2. Si el éxito fue en el flyout, se abre para que se vea el "Listo…"; si
      fue en el footer o en la página, el flyout ya no sube en esa visita.
   3. Bajo el "Listo…" va el botón "Entrar a mi cuenta" (/account): el
      descuento de bienvenida NO se entrega aquí sino dentro de la cuenta del
      cliente (decisión de Andrés, 30-sep-2026: que la persona entre al
      ecosistema antes de acceder al código). El código vive en la app Hai
      Cuenta y su validez la decide el descuento del admin.
   4. Ganchos de prueba en la URL: `?hai_captura=abrir` borra la cookie y abre
      el flyout al cargar; `?hai_captura=exito` además simula el estado
      "Listo…" para revisar el copy. Solo si el flyout está en la página: con
      sesión de cliente iniciada el tema no lo imprime.

   Todo con guardas y en silencio: es una capa de cortesía, no el flujo. */

(function () {
  'use strict';

  if (window.__haiCaptura) return;
  window.__haiCaptura = true;

  /* En un grupo de secciones el id del flyout es `sections--<grupo>__hai_captura`
     (el número cambia al duplicar o publicar el tema): se busca por sufijo y la
     cookie del tema lleva ese mismo id. */
  var SUFIJO = '__hai_captura';
  var nombreCookie = null;
  var UN_ANO = 365 * 24 * 60 * 60;

  var script = document.currentScript || document.querySelector('script[src*="hai-captura"]');
  var TEXTO_EXITO = (script && script.getAttribute('data-exito')) || 'Listo.';
  var TEXTO_CUENTA = (script && script.getAttribute('data-cuenta')) || 'Entrar a mi cuenta';

  function fijarCookie() {
    try {
      if (!nombreCookie) return;
      document.cookie = nombreCookie + '=true; max-age=' + UN_ANO + '; path=/';
    } catch (e) { /* sin cookies: el tema decide solo */ }
  }

  function exito(raiz) {
    return !!(raiz || document).querySelector('.success-color');
  }

  /* Tras cada "Listo…" de un formulario de newsletter, la salida a la cuenta.
     El CSS esconde el campo y el botón de ese formulario (ya está suscrito). */
  function anotarCuenta() {
    var mensajes = document.querySelectorAll('form .success-color');
    Array.prototype.forEach.call(mensajes, function (mensaje) {
      var form = mensaje.closest('form');
      if (!form || form.querySelector('.hai-captura__cuenta')) return;
      var enlace = document.createElement('a');
      enlace.className = 'hai-captura__cuenta';
      enlace.href = '/account';
      enlace.textContent = TEXTO_CUENTA;
      mensaje.insertAdjacentElement('afterend', enlace);
    });
  }

  function cuandoExista(fn) {
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('promo-popup').then(fn, fn);
    } else {
      fn();
    }
  }

  function abrirParaProbar(flyout) {
    var id = flyout.getAttribute('data-section-id');
    try { document.cookie = id + '=; max-age=0; path=/'; } catch (e) { /* sin cookies */ }
    cuandoExista(function () {
      if (typeof flyout.openPopup === 'function') flyout.openPopup();
    });
  }

  function simularExito(flyout) {
    var form = flyout.querySelector('form');
    if (!form || form.querySelector('.success-color')) return;
    var h = document.createElement('h3');
    h.className = 'subheading success-color';
    h.textContent = TEXTO_EXITO;
    form.insertBefore(h, form.firstChild);
  }

  function alListo() {
    var flyout = document.querySelector('promo-popup[data-section-id$="' + SUFIJO + '"]');
    var modo = (window.location.search.match(/[?&]hai_captura=(abrir|exito)(&|$)/) || [])[1];

    if (flyout && modo === 'abrir') {
      abrirParaProbar(flyout);
      return;
    }
    if (flyout && modo === 'exito') {
      simularExito(flyout);
      anotarCuenta();
      abrirParaProbar(flyout);
      return;
    }

    if (!exito()) return;
    anotarCuenta();

    if (!flyout) return; /* sin flyout en la página (cliente con sesión) no hay cookie que fijar */
    nombreCookie = flyout.getAttribute('data-section-id');

    fijarCookie();

    /* El tema vuelve a escribir la cookie (168 h) al cerrar con la X o con
       Escape; se repone la larga justo después. */
    document.addEventListener('click', function (evento) {
      if (evento.target.closest && evento.target.closest('[data-popup-toggle]')) {
        window.setTimeout(fijarCookie, 50);
      }
    });
    document.addEventListener('keydown', function (evento) {
      if (evento.key === 'Escape') window.setTimeout(fijarCookie, 50);
    });

    cuandoExista(function () {
      if (exito(flyout) && typeof flyout.openPopup === 'function') {
        flyout.openPopup();
      } else {
        /* El éxito fue en otro formulario: que el flyout no suba hoy. */
        flyout.hasPopupedUp = true;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', alListo);
  } else {
    alListo();
  }
})();
